export const ENDPOINT = {
  GET_REF_DATA: "get-ref-data",
  GET_RECORD_LIST: "get-filtered-results",
  ADD_REVIEW: "submit-records",
  RECORD_INFO: "get-record-data",
  SAMPLE_GENERATION: "sample-records",
  EXPORT_RECORD: "get-export",
  RATING: "load-translation-rating",
  GET_RECORD_LIST_BY_NEEDS_REVIEW: "get-needs-review-results",
  GET_DASHBOARD_DATA: "get-dashboard-data",
  GET_NO_RISK_DATA: "get-no-risk-results",
  GET_NOTIFICATION_DATA: "get-notification-data",
  GET_AUDIT_LOGS: "get-audit-logs",
  EXPORT_AUDIT_LOGS: "get-export-audit-logs",
  GET_REVIEWED_LIST: "get-reviewed-results",
  EXPORT_POLL_DATA: "poll-export",
  SEARCH_RECORDS: "search-records",
  LOGOUT: "logout",
};
